import React from 'react';
import PropTypes from 'prop-types';

const Thumbnail = ({src}) => (
  <img width="50" src="https://media.moddb.com/images/engines/1/1/984/img-placeholder.1.jpg" />
)

export default Thumbnail;